<template>
<v-card>
    <v-toolbar flat tabs color="grey lighten-3">
        <v-toolbar-side-icon @click="$emit('close')" :disabled="loading">
            <v-icon color="primary">close</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>Importação de produtos</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
        <v-layout wrap>
            <input
                type="file"
                ref="file"
                style="display:none;"
                accept="text/csv"
                @change="onFilePicked"
            >
            <v-flex xs12>
                <v-text-field
                    :disabled="loading"
                    label="Selecione o arquivo de importação" 
                    @click='$refs.file.click()' 
                    v-model='fileName' 
                    prepend-icon='attach_file'
                    :append-icon="fileName?'cancel':''"
                    @click:append="clearFile"
                    :error-messages="error"
                    :success-messages="(successQtd > 0)?success:[]"
                    :hint="products.length>0?`${products.length} produtos carregados`:''"
                    persistent-hint
                >
                </v-text-field>
            </v-flex>
        </v-layout>
        <template v-if="!importFields">
            <v-subheader>Configurar Modelo de arquivo</v-subheader>
            <span v-if="restaurant.product_import_settings" class="pl-3">
                Modelo atual:
                <span v-for="(keys) in Object.keys(restaurant.product_import_settings.fields)" :key="keys">
                    <span class="font-weight-black">
                        {{keys}}:
                    </span>
                    {{productFields.find(v=>v.value==restaurant.product_import_settings.fields[keys]).text}}
                </span>
            </span>
            <v-data-table
                :loading="loadingTable"
                v-if="products.length > 0"
                :headers="headersTable"
                :items="products.slice(0,5)"
                disable-initial-sort 
                :rows-per-page-items='[5]'
            >   
                <template #headerCell="{header}">
                    <v-select
                        :items="productFields"
                        label="Campo" hide-details
                        v-model="header.field"
                    ></v-select>
                    <th class="py-2 text-xs-center">
                        {{header.text}}
                    </th>
                </template>
                <template #items="props">
                    <td v-for="key in Object.keys(props.item)" :key="key" class="text-xs-center">
                        {{props.item[key]}}
                    </td>
                </template>
                <template #actions-prepend>
                    <v-layout>
                        <v-flex pr-2>
                            <v-checkbox
                            v-model="importOption"
                            label="Salvar da loja modelo"
                            hide-details
                            ></v-checkbox>
                        </v-flex>
                        <v-flex>
                            <v-checkbox
                            hide-details
                            v-model="header"
                            @change='csvJSON'
                            label="Possui cabeçalho"
                            ></v-checkbox>
                        </v-flex>
                    </v-layout>
                </template>
                <template #actions-append>
                    <v-btn color="success" @click="saveModel">Salvar modelo</v-btn>
                </template>
            </v-data-table>
        </template>
        <template v-else>
            <v-layout align-start>
                <v-btn flat small color="primary" @click="changeModel" 
                    :disabled="products.length == 0 || loading">
                    Modificar modelo
                </v-btn>
                <v-flex>
                    <v-checkbox
                    v-if="!importOption"
                    class="mt-0"
                    hide-details
                    v-model="createNewProducts"
                    label="Cadastrar Novos Produtos"
                    ></v-checkbox>
                </v-flex>
            </v-layout>
        </template>
        <v-alert
        v-if="newProductsQtd > 0"
        :value="true"
        type="warning"
        dismissible
        >
            {{newProducts}}
        </v-alert>
        <v-alert
        v-for="error in importErrors"
        :key="error"
        :value="true"
        type="error"
        dismissible
        >
            {{error}}
        </v-alert>
    </v-card-text>
    <v-card-actions>
        <v-layout row justify-center>
            <v-flex xs4>
                <v-btn color="success" large block class="mb-3" :disabled="!ok" :loading="loading" @click="finish">
                    Importar
                </v-btn>
            </v-flex>
        </v-layout>
    </v-card-actions>
    <template v-if="loading">
        <v-layout v-if="importOption">
            <span class="pl-2 body-2">{{`Parte ${now}/${parts}`}}</span>
            <span class="pl-4 body-2" v-if="attempts > 0">Tentativa: {{attempts}}</span>
        </v-layout>
        <v-progress-linear v-model="progress" class="my-0"></v-progress-linear>
    </template>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import io from 'socket.io-client'
import languageEncoding from 'detect-file-encoding-and-language';

export default {
    data(){
        return{
            loading:false,
            fileName:'',
            file:null,
            products:[],
            headersTable:[],
            importErrors:[],
            successQtd:0,
            newProductsQtd:0,
            error:'',
            header:false,
            productFields:[
                {value:'',text:'Ignorar'},
                {value:'code',text:'Código'},
                {value:'bar_code',text:'Cód. Barras'},
                {value:'productname',text:'Nome'},
                {value:'price',text:'Preço'},
                {value:'stock',text:'estoque'},
            ],
            importOption:false,
            createNewProducts:false,
            importFields:null,
            loadingTable:false,
            //progress
            progress:0,
            productsImport:[],
            now:0,
            parts:0,
            syncProgress:null,
            syncHelper:0,
            syncStep:0.999,
            //attempts
            attempts:0,
            wait:null
        }
    },
    mounted(){
        if(this.restaurant.product_import_settings){
            this.importSettings()
        }
    },
    beforeDestroy(){
        if(this.syncProgress){
            clearInterval(this.syncProgress)
        }
        this.timeoutCleaner()
    },
    computed: {
        ...mapGetters([
            'restaurant'
        ]),
        ok(){
            return this.products.length > 0 && this.importFields
        },
        success(){
            return `${this.successQtd} Produtos atualizados`
        },
        newProducts(){
            return `${this.newProductsQtd} Produtos pendentes`
        }
    },
    watch:{
        file(v){
            if(!v){
                this.fileName = ''
                this.products = []
            }else{
                this.importErrors = []
                this.successQtd = 0
                this.newProductsQtd = 0
            }
        }
    },
    methods:{
        importSettings(){
            this.importFields = this.restaurant.product_import_settings.fields
            this.header = this.restaurant.product_import_settings.header
            this.importOption = this.restaurant.product_import_settings.option
        },
        changeModel(){
            this.headersTable.map(h=>{
                if(h.value in this.importFields){
                    h.field = this.importFields[h.value]
                }
            })
            this.importFields = null
        },
        async saveModel(){
            try {
                const data = {
                    product_import_settings:{
                        fields:this.getConfig(),
                        option:this.importOption,
                        header:this.header,
                    }
                }
                this.loadingTable = true
                await this.$store.dispatch('modifyRestaurant',data)
                this.importSettings()
                this.error = ''
            } catch (error) {
                console.log(error)
                this.error = error
            } finally {
                this.loadingTable = false
            }
        },
        getData(){
            return this.products.map(v=>{
                let aux = Object.assign({},v)
                for(let h of Object.keys(aux)){
                    if(h in this.importFields){
                        aux[this.importFields[h]] = aux[h]
                    }
                    delete aux[h]
                }
                return aux
            })
        },
        getConfig(){
            const r = {}
            this.headersTable.forEach(v=>v.field?r[v.value]=v.field:null)
            return r
        },
        scrollTable(evt){
            console.log(evt);
        },
        clearFile(){
            this.fileName = ''
            this.file = null
            this.products = []
            this.$refs.file.value = ''
        },
        async refreshProducts(){
            await this.$store.dispatch('fetchMenu')
            await this.$store.dispatch('fetchProducts')
        },
        timeoutCleaner(){
            clearTimeout(this.wait)
            this.wait = null
        },
        timeoutRetry(delay=10000){
            if(this.wait){
                this.timeoutCleaner()
            }

            this.wait = setTimeout(() => {
                if(this.attempts == 6){
                    this.attempts = 0
                    this.loading = false
                    this.error = "Houve um erro na conexão. Tente novamente mais tarde."
                }else{
                    this.now--
                    this.step()
                    this.attempts++
                }
            }, delay);
        },
        listenProgress(){
            const token = this.$store.state.token;
            const socket = io({
                transports: ['websocket'],
                query: { token }
            });
            socket.on('progress',data=>{
                if(data.part == this.now){
                    this.timeoutRetry()
                    this.progress = data.progress;
                    if(data.complete){
                        this.attempts = 0
                        this.importErrors.concat(data.resume.errors)
                        this.successQtd += data.resume.products
                        this.newProductsQtd += data.resume.new
                        if(this.now < this.parts){
                            this.step()
                        }else{
                            this.clearFile()
                            this.timeoutCleaner()
                            this.error = ''
                            this.loading = false
                        }
                    }
                }
            });
        },
        async step(){
            try {
                this.progress=0
                const data = {
                    products:this.productsImport,
                    importFromModel:this.importOption,
                    createNewProducts:this.createNewProducts
                }
                if(this.importOption){
                    data.part = ++this.now
                    data.products = data.products.slice((this.now-1)*1000,this.now*1000)
                    data.async = true
                }else{
                    this.syncProgress = setInterval(() => {
                        if(this.syncHelper == 20){
                            this.syncStep -= 0.111
                            this.syncHelper = 0
                        }
                        this.progress += this.syncStep
                        this.syncHelper++
                    }, 1000);
                }
                const res = await this.$store.dispatch('importProducts',data)
                this.$store.dispatch('fetchMenu')
                this.$store.dispatch('fetchProducts')
                this.error = ''
                if(this.importOption){
                    this.listenProgress()
                }else{
                    this.loading = false
                    clearInterval(this.syncProgress)
                    this.syncProgress = null
                    this.clearFile()
                    this.importErrors = res.errors.slice(0,10)
                    if(res.errors.length > 10){
                        this.importErrors = [...this.importErrors,`e outros ${res.errors.slice(11).length} erros`]
                    }
                    this.successQtd = res.products.length
                    this.newProductsQtd = res.new.length
                }
            } catch (error) {
                if(this.importOption && error.message == 'Network Error'){
                    this.timeoutRetry(3000)
                }else{
                    this.error = error.message || error;
                    this.loading = false
                    this.attempts = 0
                }
            }
        },
        finish(){
            this.successQtd=0
            this.newProductsQtd=0
            this.loading = true
            this.productsImport = this.getData()
            this.parts = Math.ceil(this.productsImport.length/1000)
            this.now = 0
            this.step()
        },
        async onFilePicked (e) {
            const files = e.target.files
            if(files[0]) {
                this.fileName = files[0].name
                const fileInfo = await languageEncoding(files[0])
                const fr = new FileReader()
                fr.readAsText(files[0],(fileInfo.encoding === 'UTF-8')?'UTF-8':'WINDOWS-1252')
				fr.addEventListener('load', (evt) => {
                    this.file = evt.target.result
                    this.csvJSON()
				})
            }
        },
        csvJSON(){
            const hAlias = {
                'code':['código','codigo','code','plu'],
                'bar_code':['bar_code','cod_barras','codigo_barra','codigo_barras','cod barras', 'cód barras'],
                'productname':['name','nome','produto'],
                'price':['price','preco','preço','vlr_produto'],
                'stock':['stock','estoque','qtd_estoque_atual']
            }
            this.file = this.file.replace(/'/g,'').replace(/"/g,'')
            const lines=this.file.split("\n");

            const result = [];

            let headersTable
            this.headersTable = []
            if(this.header){
                headersTable=lines[0].split(";");
                headersTable.map(h=>{
                    if(h.trim()){
                        let field = ''
                        Object.keys(hAlias).
                            forEach(v=>{
                                if(hAlias[v].indexOf(h.trim().toLowerCase())!=-1){
                                    field = v
                                }
                            })
                        this.headersTable.push({
                            text:h.trim(),
                            value:h.trim(),
                            field:field,
                            sortable: false
                        })
                    }
                })
            }else{
                for(let v of Array(lines[0].split(';').length).keys()){
                    this.headersTable.push({
                        text:`Campo ${v+1}`,
                        value:v,
                        sortable: false,
                        field:''
                    })
                }
            }

            for(let i=(this.header)?1:0;i<lines.length;i++){
                if(lines[i].trim().replace(';','')){
                    const obj = {};
                    const currentline=lines[i].split(";");
                    for(let j=0;j<this.headersTable.length;j++){
                        obj[(this.header)?this.headersTable[j].value:j] = currentline[j]
                        // if(['price','stock'].indexOf(headers[j]) != -1){
                        //     obj[headers[j]] = Number.parseFloat(currentline[j].replace(",","."))
                        // }else{
                            
                        // }
                    }

                    result.push(obj);
                }

            }
            this.products = result
        }
    }

}
</script>

<style>

</style>